module.exports = __webpack_public_path__ + "img/sSuperFor_193x205.3d84710d.png";